module.exports = __webpack_public_path__ + "img/cuff_spec_elastic_width.15179614.png";